/**
 * @desc 获取年度销售计划指标数据详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** indicatorCodeList */
  indicatorCodeList: Array<string>;
  /** salePlanId */
  salePlanId: string;
  /** salePlanType */
  salePlanType: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleYearDetailResponse>>> {
  return defHttp.get({
    url: '/wap/sale/year/searchIndicatorDetail',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPlanSaleYearDetailResponse>>> {
  return defHttp.get({
    url: '/mock/wap/sale/year/searchIndicatorDetail',

    params,
  });
}
